var _defs, _rect, _polygon, _polygon2, _rect2, _polygon3, _polygon4, _polygon5, _path, _path2, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _rect3, _polygon11, _polygon12, _polygon13, _rect4, _polygon14, _polygon15, _path3, _path4, _polygon16, _path5, _rect5, _path6, _rect6, _polygon17, _polygon18, _path7, _polygon19, _polygon20, _polygon21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZonffLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714.32 203.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 404.16,
    y: 1.76,
    width: 19.83,
    height: 86.03
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "452.4 26.91 434.63 44.69 452.4 62.47 452.4 26.91"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "470.37 26.91 470.37 1.78 439.13 1.78 470.37 26.91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 313.8,
    y: 1.76,
    width: 19.83,
    height: 86.03
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "362.05 26.91 344.27 44.69 362.05 62.47 362.05 26.91"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380.01 26.91 380.01 1.78 348.77 1.78 380.01 26.91"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.87 87.78 0.05 87.78 56.35 1.76 80.17 1.76 23.87 87.78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.18,483.49a45.68,45.68,0,0,1-38.41,45.1,76.67,76.67,0,0,0,0-90.18A45.67,45.67,0,0,1,794.18,483.49Z",
    transform: "translate(-602.84 -438.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.42,528.61a45.67,45.67,0,0,1,0-90.22,76.63,76.63,0,0,0,0,90.22Z",
    transform: "translate(-602.84 -438.39)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 26.91 0 1.78 31.24 1.78 0 26.91"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "214.38 28.46 214.38 1.76 288.05 61.08 288.05 87.78 214.38 28.46"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "287.94 26.91 287.94 1.78 256.7 1.78 287.94 26.91"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "214.38 62.47 214.38 87.78 245.84 87.78 214.38 62.47"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.69 62.47 76.69 87.78 45.23 87.78 76.69 62.47"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 467.46,
    y: 117.2,
    width: 19.83,
    height: 86.03
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "515.71 142.36 497.93 160.14 515.71 177.92 515.71 142.36"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.67 142.36 533.67 117.22 502.43 117.22 533.67 142.36"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.67 178.09 533.67 203.23 502.43 203.23 533.67 178.09"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 290.76,
    y: 117.22,
    width: 20.06,
    height: 86.01
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "346.02 142.36 346.02 117.22 314.78 117.22 346.02 142.36"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.56 142.36 255.56 117.22 286.8 117.22 255.56 142.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M622.8,555.82v85.79h-20V555.82Zm23.5-.23a23.67,23.67,0,0,1,9.92,2.12,25.13,25.13,0,0,1,8.1,5.78,27.64,27.64,0,0,1,5.42,8.65,28.53,28.53,0,0,1,2,10.71,29.64,29.64,0,0,1-2,11,26.76,26.76,0,0,1-5.42,8.65,24.08,24.08,0,0,1-8.16,5.61,26,26,0,0,1-10.21,2h-7a17.41,17.41,0,0,0,4.67-4.18,28.43,28.43,0,0,0,3.77-6.24,36.63,36.63,0,0,0,2.45-7.85,45.93,45.93,0,0,0,.86-9,46.65,46.65,0,0,0-.86-9.11,35.56,35.56,0,0,0-2.45-7.79,28.94,28.94,0,0,0-3.77-6.18,17.41,17.41,0,0,0-4.67-4.18h7.3Z",
    transform: "translate(-602.84 -438.39)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M732.46,641.61H755l-44.33-87-11.32,22.17Z",
    transform: "translate(-602.84 -438.39)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.68 175.28 63.4 203.23 91.94 203.23 77.68 175.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.9,622.29a25.78,25.78,0,0,0,2.68,11.9,16,16,0,0,0,7.1,7.42h-9.46a25.89,25.89,0,0,1-10.4-1.84,19,19,0,0,1-6.73-4.66,16.46,16.46,0,0,1-3.57-6.26,22.56,22.56,0,0,1-1-6.56,24.75,24.75,0,0,0-2.73-11.73,16.81,16.81,0,0,0-6.94-7.36h-.1a16.28,16.28,0,0,0,4.83-3.62,23.51,23.51,0,0,0,3.78-5.47,30.53,30.53,0,0,0,2.47-6.9,34.24,34.24,0,0,0,.9-7.93,31.4,31.4,0,0,0-3.32-14.67,19.67,19.67,0,0,0-8.66-9h9.56a20.83,20.83,0,0,1,17.13,8,23.42,23.42,0,0,1,4,7.71,27.75,27.75,0,0,1,1.26,8,34.32,34.32,0,0,1-1,8,29.11,29.11,0,0,1-3,7.76,19.28,19.28,0,0,1-5.1,5.87,11.39,11.39,0,0,1-7,2.3h3.36a8,8,0,0,1,5.1,1.78,14.75,14.75,0,0,1,3.78,4.6,26.57,26.57,0,0,1,2.36,6.21A27.1,27.1,0,0,1,838.9,622.29Z",
    transform: "translate(-602.84 -438.39)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.52,
    y: 117.2,
    width: 20.07,
    height: 86.03
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1229.81,622.29a25.65,25.65,0,0,0,2.68,11.9,16.05,16.05,0,0,0,7.09,7.42h-9.45a25.9,25.9,0,0,1-10.41-1.84,19.06,19.06,0,0,1-6.72-4.66,16.46,16.46,0,0,1-3.57-6.26,22.23,22.23,0,0,1-1-6.56,24.76,24.76,0,0,0-2.74-11.73,16.73,16.73,0,0,0-6.93-7.36h-.11a16.32,16.32,0,0,0,4.84-3.62,23.51,23.51,0,0,0,3.78-5.47,31,31,0,0,0,2.47-6.9,34.79,34.79,0,0,0,.89-7.93,31.4,31.4,0,0,0-3.31-14.67,19.64,19.64,0,0,0-8.67-9h9.56a20.83,20.83,0,0,1,17.13,8,23.45,23.45,0,0,1,4,7.71,27.75,27.75,0,0,1,1.26,8,34.86,34.86,0,0,1-1,8,28.8,28.8,0,0,1-3,7.76,19,19,0,0,1-5.1,5.87,11.37,11.37,0,0,1-7,2.3h3.37a8,8,0,0,1,5.09,1.78,14.64,14.64,0,0,1,3.79,4.6,26.57,26.57,0,0,1,2.36,6.21A27.1,27.1,0,0,1,1229.81,622.29Z",
    transform: "translate(-602.84 -438.39)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 558.43,
    y: 117.2,
    width: 20.07,
    height: 86.03
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "711.73 140.51 711.73 117.22 682.78 117.22 711.73 140.51"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "649.73 179.79 649.73 203.08 678.68 203.08 649.73 179.79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1317.15,615.31a29.54,29.54,0,0,1-9.89,20.37,38.31,38.31,0,0,1-8.44,5.93c2.29-1.18,8.32-15.73,1-24.89-3.73-4.75-9.88-7.33-15.67-9.27-7.6-2.7-15.68-4.53-22.31-9a22.86,22.86,0,0,1-10.74-17.24,24.72,24.72,0,0,1,3.86-15.52c2.17-3.45,6.52-7.22,12.18-10.13a14.84,14.84,0,0,0-2.77,8.4c-.24,7,2.89,12.61,8.2,16.6a36.78,36.78,0,0,0,11,5c8.45,2.37,17.49,4,24.48,9.27a21.16,21.16,0,0,1,6.64,7.76A25.58,25.58,0,0,1,1317.15,615.31Z",
    transform: "translate(-602.84 -438.39)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.21 143.91 370.21 117.2 443.88 176.52 443.88 203.23 370.21 143.91"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "443.77 142.36 443.77 117.22 412.53 117.22 443.77 142.36"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.21 177.92 370.21 203.23 401.67 203.23 370.21 177.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonffLogo);
export default __webpack_public_path__ + "static/media/zonff_logo.7de0029b109d7274856a125f1630e603.svg";
export { ForwardRef as ReactComponent };